var app = angular.module("leonardo");

var TaskResolveDocumentDialog = function($scope, $rootScope, ngDialog, FormErrorsService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.data = {
    resolution_time: 0
  };
  $scope.attachments = [];
  $scope.resolution_format = 'minutes';

  $scope.removeAttachment = function(index) {
    $scope.attachments.splice(index, 1);
  };

  $scope.showAttachFileDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/folder-file/upload.html',
      controller: 'FolderFileAdd',
      resolve: {
        folder: ['FolderService', function (FolderService) {
          return null;
        }]
      },
      data: {
        entity: null,
        action: 'resolve'
      }
    }).then(function(folder_file){
      $scope.attachments.push(folder_file);
    }, function () {
      return;
    });
  };

  $scope.submit = function(task) {
    $scope.Form.$setSubmitted();
    if ($scope.attachments.length === 0) {
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    if ($scope.resolution_format === 'hours') {
      data['resolution_time'] *= 60;
    }
    var fd = new FormData();
    fd.append('file', $scope.attachments[0].file);
    data['document_file'] = $scope.attachments[0].file;
    data['document_file']['file'] = fd;
    data['document_file_name'] = $scope.attachments[0].name;
    data['document_file_expiration'] = $scope.attachments[0].expiration;
    data['document_file_notice'] = $scope.attachments[0].notice;
    data['document_file_notice_type'] = $scope.attachments[0].notice_type;
    data['completed_date'] = moment().format('YYYY-MM-DD');
    data['status'] = 1;
    $scope.task.resolveTask(data).then(function(data_result) {
      var result = data_result.data ? data_result.data : data_result;
      $scope.closeThisDialog();
      $rootScope.$broadcast('task-resolve-dialog:success', result);
    });
  };
};

app.controller('TaskResolveDocumentDialog', ['$scope', '$rootScope', 'ngDialog', 'FormErrorsService',
  TaskResolveDocumentDialog]);
